import { render, staticRenderFns } from "./BlockDetail.m.vue?vue&type=template&id=ed60966e&"
import script from "./BlockDetail.m.vue?vue&type=script&lang=js&"
export * from "./BlockDetail.m.vue?vue&type=script&lang=js&"
import style0 from "./BlockDetail.m.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports